<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>
                Assign Status To Contact Data
                {{ campaignName != null ? campaignName : "" }}
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>

          <div class="vx-row">
            <div class="ml-10">
              <h6>Choose Status :</h6>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <v-select
                name="contact_status"
                label="status"
                :options="all_sd_status"
                v-model="selected_status"
                v-validate="'required'"
                data-vv-as="Contact Status"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('contact_status')"
                >{{ errors.first("contact_status") }}</span
              >
            </div>


    <div class="vx-col sm:w-1/6 w-full" v-if="sub_statuses.length > 0">
                     <template v-for="sub_status in sub_statuses">
                        <input 
                          v-validate="'required'"
                          data-vv-as="Sub Status"
                          name="sub_status"
                          v-model="selected_sub_status"
                          :value="sub_status"
                          type="checkbox">
                         <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                       </br>
               </template>
             
             
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <vs-textarea
                class="w-full mb-2"
                name="contact_status_notes"
                v-model="contact_status_notes"
                v-validate="'required'"
                data-vv-as="Contact Status Notes"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('contact_status_notes')"
                >{{ errors.first("contact_status_notes") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-button @click.prevent="updateStatusToSDContact"
                >Submit</vs-button
              >
            </div>
          </div>

          <!-- 
          <div class="vx-row">
            <div class="m-5">
              <h6>Choose Status :</h6>
            </div>

            <div class="vx-col sm:w-1/6 w-full">
               <v-select
                label="status"
                :options="all_sd_status"
                v-model="selected_status"
              />
            </div>
           

            <vs-button @click.prevent="updateStatusToSDContact">Submit</vs-button>
             
          </div> -->
          <div>
            <DataGrid :context="'SDQCContact'" 
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="SDQCContact"
              :columnDefs="contactsColumnDefs"
              :rowData="contactRecords"
              :dataSource="contactDataSource"
              :rowSelection="'multiple'"
            >
            </DataGrid>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import ContactAutocomplete from "@/components/autocomplete/ContactsAutocomplete.vue";
export default {
  beforeMount() {
    this.getContactDataSource();
  },
  data() {
    return {
       user_role_id: null,
    sub_statuses: [],
    selected_sub_status: [],
      authorized:true,
      contact_status_notes: null,
      all_sd_status: [],

      showCampaignSelection: true,
      showDastatusrid: false,
      contactsColumnDefs: [],
      selected_campaign: null,
      contactDataSource: {},
      contactRecords: [],
      campaignId: null,
      campaignName: null,
      selected_table_ids: [],
      selected_sales_developer_id: null,
      selected_status: []
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    ContactAutocomplete,
    CampaignAutocomplete,
    moduleSDSubStatusManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
   this.user_role_id = userInfo['roleId'] // userInfo['role_id']

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

      if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }

    this.campaignName = atob(this.$route.params.campaignName);

    this.checkSalesDeveloperCampaignPermission()

  },
  mounted() {
    if(this.authorized){
    this.fetchAllSDStatus();
    }
  },
  watch: {
       selected_status (val) {
      if (val) {
        console.log("STATUS CHANGED" , val)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id , this.user_role_id)
      }
    },
  },
  methods: {
             fetchSDSubStatusByStatusIDAndRoleID(status_id,role_id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID", {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data);

         self.sub_statuses = []


             result.forEach(function (ele) {
           if (ele.level == 'contact'){
                self.sub_statuses.push(ele)
           }
          

 })

  



        })
        .catch(err => {
          console.error(err);
        });
    },
    checkSalesDeveloperCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkSalesDeveloperCampaignPermission" , data)
        .then(res => {
          let result = res.data
          if (!result){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    fetchAllSDStatus() {
      this.$store
        .dispatch("campaignsManagement/fetchAllSDStatus")
        .then(res => {
          let result = res.data;
          this.all_sd_status = result;
        })
        .catch(err => {
          console.error(err);
        });
    },
    sendSelectionToActualPage(items) {
      let selected_table_ids = [];
      items.forEach(element => {
  

        console.log("ELEMENT" , element.data)


        selected_table_ids.push(element.data.table_id);
      });

      this.selected_table_ids = selected_table_ids;
    },
    updateStatusToSDContact() {
      if (this.selected_table_ids.length == 0) {
        return false;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;
          let data = {};
          data.table_ids = self.selected_table_ids;
          data.contact_status = self.selected_status.status;
          data.contact_status_notes = self.contact_status_notes;

          data.campaign_id = self.$route.params.campaignId;
          data.campaign_name = self.campaignName;
          data.sales_developer_id = self.user_id;
          data.level = "contact";

            let newSubStatusArray = []

      if (self.selected_sub_status.length != 0) {
        for (let i = 0; i < self.selected_sub_status.length; i++) {
          newSubStatusArray.push(self.selected_sub_status[i].uuid)
        }
        newSubStatusArray = JSON.stringify(newSubStatusArray)
      }
      else{
        newSubStatusArray = null
      }

      data.contact_sub_status = newSubStatusArray

          self.$store
            .dispatch("campaignsManagement/updateStatusToSDAccount", data)
            .then(res => {
              if (res) {
                if (res.data.status == "success") {
                                location.reload();

                  self.$refs.SDQCContact.gridApi.deselectAll();

                  self.selected_table_ids = [];
                  // self.selected_status = [];
                  // self.contact_status_notes = null;

                  self.$refs.SDQCContact.gridApi.refreshServerSide({purge : true});
                  self.getContactDataSource();
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getContactDataSource() {
      var self = this;
      self.contactDataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);

          self.$store
            .dispatch("accountsManagement/fetchAllSDQCContacts", params.request)
            .then(function(response) {
              let response_data = response.rows;

              response_data.forEach(function (ele) {




if(ele._0c483105_8807_4d68_8299_91f449e7085a){

  if (ele._0c483105_8807_4d68_8299_91f449e7085a.length == 0) {
  ele._0c483105_8807_4d68_8299_91f449e7085a = "";
} else if (ele._0c483105_8807_4d68_8299_91f449e7085a.length > 1) {
  ele._0c483105_8807_4d68_8299_91f449e7085a = "ΞΞ";
} else {
  ele._0c483105_8807_4d68_8299_91f449e7085a = ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi_phone_code + ele._0c483105_8807_4d68_8299_91f449e7085a[0].ddi;
}

}


if(ele._f045b88c_3b21_4a30_9576_f566641e3447){

if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length == 0) {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "";
} else if (ele._f045b88c_3b21_4a30_9576_f566641e3447.length > 1) {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = "ΞΞ";
} else {
  ele._f045b88c_3b21_4a30_9576_f566641e3447 = ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile_phone_code + ele._f045b88c_3b21_4a30_9576_f566641e3447[0].mobile;
}
}

if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849) {

                      let all_social_medias = ele._2619e88b_cc7c_48bd_8934_de7113d6b849

                    if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ''
                    } else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = 'ΞΞ'
                      ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    } else {
                      ele._2619e88b_cc7c_48bd_8934_de7113d6b849 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].social_media
                        ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = all_social_medias[0].summary;

                    }
                  }


if(ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d){

  if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length == 0) {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "";
  } else if (ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d.length > 1) {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = "ΞΞ";
  } else {
    ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d = ele._7f678dc8_5d41_4ca3_aaad_deedfb594a6d[0].email;
  }
}
});



            
              if (response_data.length != 0) {
                self.$refs.SDQCContact.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.SDQCContact.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getSDContactColumns() {
      let self = this;

      self.$store
        .dispatch(
          'campaignsManagement/getAllContactSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let contact_columns = JSON.parse(res.data);


          contact_columns = contact_columns.filter(function(ele) {
            return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'ddi' && ele.identifier != 'mobile' && ele.identifier != 'contact_status' && ele.identifier != 'contact_status_notes' && ele.identifier != 'grade'   
            });


            



            var index = 1;
            contact_columns.forEach(function(ele) {

              


              ele.id = ele.uuid

          

          
              ele.headerName = ele.name;

              ele.field = '_' + ele.id.replaceAll("-", "_");

              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


            this.contactsColumnDefs = contact_columns


            let actions = {
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.contactsColumnDefs.push(actions)


          let contact_status = {
        column_name: "contact_status",
        field: "contact_status",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Contact Status"
      };

      this.contactsColumnDefs.push(contact_status);

        let contact_sub_status = {
        column_name: "contact_sub_status",
        field: "contact_sub_status",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Contact Sub Status"
      };

      this.contactsColumnDefs.push(contact_sub_status);


      let contact_status_notes = {
        column_name: "contact_status_notes",
        field: "contact_status_notes",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Contact Status Notes"
      };

      this.contactsColumnDefs.push(contact_status_notes);

      let grade = {
        column_name: "grade",
        field: "grade",
        filter: "agNumberColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Grade"
      };

      this.contactsColumnDefs.push(grade);


        })
        .catch(err => {
          console.log(err)
        })
     
    }
  },
  beforeMount() {
    this.getSDContactColumns();
    this.getContactDataSource();
    this.$refs.SDQCContact.gridApi.showNoRowsOverlay();
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.vertical-align {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  /* width: 800px; */
}
</style>
